import ConfirmModal from '../../common/ConfirmModal';

interface SendReminderModalProps {
  totalCount: number;
  isModalOpen: boolean;
  onClose: () => void;
  action: () => void;
}

export const BulkSendReminderModal = ({
  totalCount,
  isModalOpen,
  onClose,
  action,
}: SendReminderModalProps) => {
  return (
    <ConfirmModal
      title={`再招待メール送信`}
      btitle='送信'
      description={`${totalCount}名のユーザーに再度招待メールを送信します。
よろしいですか？`}
      show={isModalOpen}
      onClose={onClose}
      action={action}
    />
  );
};
